// @ts-nocheck
import { customerPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(customerPartNumberStyles, {
    labelText: {
        transform: "uppercase",
        css: css`
            margin-right: 0.25em;
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    valueText: {
        css: css`
            display: inline-block;
            margin-right: ${pxToRem(20)};
            font-weight: ${x => x.theme.design.typography.weight.medium};
        `,
    },
});
